// Simulador.jsx
import React, { useState, useRef, useEffect} from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    ScrollView,
    KeyboardAvoidingView,
    TouchableWithoutFeedback,
    Keyboard,
    ActivityIndicator,
    Modal,
    Image,
    Platform
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { TextInputMask } from 'react-native-masked-text';
import axios from 'axios';

import BaseWeb from './components/baseWeb';
import styles from './styles/simuladorDeCreditoWebStyles';
import { useLogScreen } from '../useLogScreen';
export default function SimuladorDeCreditoWeb() {
    useLogScreen('LaudoQuadraCred');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Simulador de crédito imobiliário';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const phoneInputRef = useRef(null);
    const nomeCompletoRef = useRef(null);
    const dataNascimentoRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [phone, setPhone] = useState('');
    const [valorVendaImovel, setValorVendaImovel] = useState('');
    const [valorFinanciamentoImovel, setValorFinanciamentoImovel] = useState('');
    const [valorFGTS, setValorFGTS] = useState('');
    const [rendaBruta, setRendaBruta] = useState('');
    const [rendaLiq, setRendaLiq] = useState('');
    const [prazo, setPrazo] = useState('');
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [dataNascimento, setdataNascimento] = useState('');
    const [naoPossuiCondominio, setNaoPossuiCondominio] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const formatCurrency = (value) => {
        if (!value) return '';
        const numericValue = value.replace(/[^0-9]/g, '');
        const formattedValue = (numericValue / 100).toFixed(2).replace('.', ',');
        return 'R$ ' + formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const handlePhoneChange = (text) => {
        const numericPhone = text.replace(/\D/g, '');
        if (numericPhone.length <= 11) {
            setPhone(text);
        }
    };

    const handleDateChange = (text) => {
        setdataNascimento(text);
        if (text.length === 10) {
            const [day, month, year] = text.split('/').map(Number);
            const birthDate = new Date(year, month - 1, day);
            const today = new Date();
            const age = today.getFullYear() - birthDate.getFullYear();
            const isBirthdayPassed =
                today.getMonth() > birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
            if (age < 18 || (age === 18 && !isBirthdayPassed)) {
                setErrorMessage('Você precisa ter +18 anos');
            } else {
                setErrorMessage('');
            }
        } else {
            setErrorMessage('');
        }
    };

    const isFormValid = () => (
        valorVendaImovel && nomeCompleto && dataNascimento && phone && valorFinanciamentoImovel && rendaBruta && rendaLiq && prazo
    );

    const handleSaveImovel = async (usuario_id, emailUser) => {
        if (!isFormValid()) {
            alert('Preencha todos os campos obrigatórios.');
            return;
        }

        if (isSubmitting) return;

        setIsSubmitting(true);
        setLoading(true);

        try {
            const payload = {
                nome: nomeCompleto,
                data_nascimento: dataNascimento,
                telefone: phone,
                email: emailUser,
                valor_imovel: valorVendaImovel.replace(/[^\d]/g, '').slice(0, -2),
                valor_afinanciar: valorFinanciamentoImovel.replace(/[^\d]/g, '').slice(0, -2),
                valor_renda_bruta: rendaBruta.replace(/[^\d]/g, '').slice(0, -2),
                valor_renda_liquida: rendaLiq.replace(/[^\d]/g, '').slice(0, -2),
                valor_fgts: valorFGTS.replace(/[^\d]/g, '').slice(0, -2) || '0',
                qtd_parcelas: prazo.toString(),
            };

            const response = await axios.post('https://api2.imogo.com.br/submit_simulation', payload);

            if (response.status === 200) {
                const { imprimir_link } = response.data;
                navigation.navigate('SimuladorDeCreditoDownloadWeb', { imprimir_link });
            } else {
                alert('Ocorreu um erro ao fazer a simulação');
            }
        } catch (error) {
            console.error(error);
            alert('Não foi possível fazer a simulação');
        } finally {
            setIsSubmitting(false);
            setLoading(false);
        }
    };

    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                const emailUser = userInfo?.email;

                return (
                    <KeyboardAvoidingView
                        style={{ flex: 1 }}
                        behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                        enabled={Platform.OS !== 'web'}
                    >
                        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
                            <ScrollView contentContainerStyle={styles.contentMinimal}>
                                <View style={styles.formContainer}>
                                    <Text style={styles.title}>Simulador de crédito imobiliário</Text>

                                    {/* Nome Completo */}
                                    <View style={styles.row}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Nome Completo *</Text>
                                        <TouchableWithoutFeedback onPress={() => nomeCompletoRef.current.focus()}>
                                            <View style={styles.inputContainer}>
                                                <TextInput
                                                    ref={nomeCompletoRef}
                                                    allowFontScaling={false}
                                                    style={styles.areaInput}
                                                    placeholder="Nome Completo"
                                                    value={nomeCompleto}
                                                    placeholderTextColor="#A9A9A9"
                                                    onChangeText={setNomeCompleto}
                                                />
                                            </View>
                                        </TouchableWithoutFeedback>
                                    </View>

                                    {/* Inputs row */}
                                    <View style={styles.areaRow}>
                                        {/* Data de nascimento */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Data de nascimento *</Text>
                                            <TouchableWithoutFeedback onPress={() => dataNascimentoRef.current.focus()}>
                                                <View>
                                                    <TextInputMask
                                                        type={'datetime'}
                                                        options={{
                                                            format: 'DD/MM/YYYY'
                                                        }}
                                                        ref={dataNascimentoRef}
                                                        style={[styles.areaInput, { zIndex: 1 }]}
                                                        placeholder="00/00/0000"
                                                        value={dataNascimento}
                                                        onChangeText={handleDateChange} // Validação adicionada
                                                        placeholderTextColor="#A9A9A9"
                                                        returnKeyType="next"
                                                        onSubmitEditing={() => dataNascimentoRef.current.focus()}
                                                        blurOnSubmit={false}
                                                        keyboardType="numeric"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                            {errorMessage ? (
                                                <Text style={styles.errorText}>{errorMessage}</Text> // Exibe a mensagem de erro
                                            ) : null}
                                        </View>


                                        {/* Telefone */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Telefone *</Text>
                                            <TouchableWithoutFeedback onPress={() => phoneInputRef.current.focus()}>
                                                <View>
                                                    <TextInputMask
                                                        ref={phoneInputRef}
                                                        type={'cel-phone'}
                                                        options={{
                                                            maskType: 'BRL',
                                                            withDDD: true,
                                                            dddMask: '(99) 9 9999-9999',
                                                        }}
                                                        style={[styles.areaInput, { zIndex: 1 }]}
                                                        placeholder="(00) 0 0000-0000"
                                                        value={phone}
                                                        onChangeText={handlePhoneChange}
                                                        keyboardType="phone-pad"
                                                        returnKeyType="done"
                                                        placeholderTextColor="#A9A9A9"
                                                        maxLength={16}
                                                        onSubmitEditing={() => Keyboard.dismiss()}
                                                        allowFontScaling={false}
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>
                                    </View>

                                    {/* Separador visual (Divisão) */}
                                    <View style={styles.divider} />

                                    {/* Valor de venda do imóvel */}
                                    <View style={styles.row}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Valor de venda do imóvel *</Text>
                                        <TouchableWithoutFeedback onPress={() => { }}>
                                            <View style={styles.inputContainer}>
                                                <TextInput
                                                    style={styles.areaInput}
                                                    placeholder="R$"
                                                    value={valorVendaImovel}
                                                    onChangeText={(text) => setValorVendaImovel(formatCurrency(text))}
                                                    keyboardType="numeric"
                                                    allowFontScaling={false}
                                                    placeholderTextColor="#A9A9A9"
                                                    pointerEvents="auto"
                                                />
                                            </View>
                                        </TouchableWithoutFeedback>
                                    </View>
                                    {/* Valor que deseja financiar: */}
                                    <View style={styles.areaRow}>
                                        {/* Área Privativa */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Valor que deseja financiar *</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="R$"
                                                        value={valorFinanciamentoImovel}
                                                        onChangeText={(text) => {
                                                            const numericValue = parseFloat(text.replace(/[^\d]/g, '')) || 0; // Converte para número
                                                            const maxValue = parseFloat(valorVendaImovel.replace(/[^\d]/g, '')) * 0.8 || 0; // 80% do valorVendaImovel

                                                            if (numericValue <= maxValue) {
                                                                setValorFinanciamentoImovel(formatCurrency(text));
                                                            } else {
                                                                alert(`O valor máximo permitido é ${formatCurrency(maxValue.toString())}`);
                                                            }
                                                        }}
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>

                                        {/* Prazo */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Prazo *</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="420x"
                                                        value={prazo}
                                                        onChangeText={(text) => {
                                                            // Remove caracteres não numéricos
                                                            const numericValue = text.replace(/[^0-9]/g, '');
                                                            // Limita o valor entre 0 e 420
                                                            const limitedValue = Math.min(Math.max(parseInt(numericValue || '0', 10), 0), 420);
                                                            setPrazo(String(limitedValue));
                                                        }}
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>
                                    </View>
                                    {/* Inputs de Área */}
                                    <View style={styles.areaRow}>
                                        {/* Área Privativa */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Valor da entrada</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="R$"
                                                        value={
                                                            valorVendaImovel && valorFinanciamentoImovel
                                                                ? `${new Intl.NumberFormat('pt-BR', {
                                                                    style: 'currency',
                                                                    currency: 'BRL',
                                                                }).format(
                                                                    (parseFloat(valorVendaImovel.replace(/[^\d]/g, '')) / 100 || 0) -
                                                                    (parseFloat(valorFinanciamentoImovel.replace(/[^\d]/g, '')) / 100 || 0)
                                                                )}`
                                                                : '' // Exibe vazio se qualquer campo estiver incompleto
                                                        }
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="none" // Desativa interações com o campo
                                                        editable={false} // Torna o campo não editável
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>

                                        {/* Prazo */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Valor do FGTS *</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="R$"
                                                        value={valorFGTS}
                                                        onChangeText={(text) => setValorFGTS(formatCurrency(text))}
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        editable={!naoPossuiCondominio}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>
                                    </View>

                                    {/* Separador visual (Divisão) */}
                                    <View style={styles.divider} />
                                    {/* Inputs de Área */}
                                    <View style={[styles.areaRow, styles.mt_10]}>
                                        {/* Área Privativa */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Renda Bruta *</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="R$"
                                                        value={rendaBruta}
                                                        onChangeText={(text) => setRendaBruta(formatCurrency(text))}
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>

                                        {/* Área Total */}
                                        <View style={styles.areaColumn}>
                                            <Text style={styles.subLabel} allowFontScaling={false}>Renda Líquida *</Text>
                                            <TouchableWithoutFeedback onPress={() => { }}>
                                                <View style={styles.inputContainer}>
                                                    <TextInput
                                                        style={styles.areaInput}
                                                        placeholder="R$"
                                                        value={rendaLiq}
                                                        onChangeText={(text) => setRendaLiq(formatCurrency(text))}
                                                        keyboardType="numeric"
                                                        allowFontScaling={false}
                                                        placeholderTextColor="#A9A9A9"
                                                        pointerEvents="auto"
                                                    />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        </View>
                                    </View>

                                    <View style={styles.buttonContainer}>
                                        <TouchableOpacity
                                            style={[styles.saveButton, (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' }]}
                                            onPress={() => handleSaveImovel(usuario_id, emailUser)}
                                            disabled={!isFormValid() || isSubmitting}
                                        >
                                            <Text style={styles.saveButtonText}>{isSubmitting ? 'Enviando...' : 'Fazer Simulação'}</Text>
                                        </TouchableOpacity>
                                    </View>

                                    <Modal transparent={true} animationType="fade" visible={loading}>
                                        <View style={styles.loadingContainer}>
                                            <ActivityIndicator size="large" color="white" />
                                            <Text style={styles.loadingText}>Gerando Simulação...</Text>
                                        </View>
                                    </Modal>
                                </View>
                            </ScrollView>
                        </TouchableWithoutFeedback>
                    </KeyboardAvoidingView>
                );
            }}
        </BaseWeb>
    );
}
